import React from 'react';
import style from './PageHeader.module.css';
import TruncateText from '../CompactText/TruncateText';

type PageHeaderProps = {
  title: string;
  extraInfo: string;
  isMobileDevice: boolean;
  url?: string;
  isExtraInfoVisible?: boolean;
  viewMoreHtml?: string;
  viewLessHtml?: string;
  isHtml?: boolean;
  whiteBackground?: boolean;
};

const PageHeader = ({
  title,
  extraInfo,
  isMobileDevice,
  url = '',
  whiteBackground = false,
  viewMoreHtml,
  viewLessHtml,
  isExtraInfoVisible = false,
  isHtml
}: PageHeaderProps) => {
  return (
    <div className={`${style.pageHeader}`}>
      <div className="makeFlex column appendTop10 appendBottom10">
        <h1 className="font22 blackText latoBlack ">{title}</h1>
      </div>
    </div>
  );
};
export default PageHeader;
